import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Send, CheckCircle2, Link as LinkIcon, Unlink } from 'lucide-react';

/**
 * Telegram connection panel. Self-contained: takes status + handlers from parent.
 */
const TelegramCard = ({
  tgStatus,
  deepLink,
  linking,
  polling,
  onStartLink,
  onUnlink,
  onSendTest,
}) => (
  <Card className="mb-8" data-testid="telegram-card">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Send size={18} className="text-purple-600" /> Telegram Connection
      </CardTitle>
    </CardHeader>
    <CardContent>
      {!tgStatus?.enabled ? (
        <p className="text-sm text-red-600">Telegram is not configured on the server.</p>
      ) : tgStatus?.linked ? (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-sm">
            <CheckCircle2 size={18} className="text-green-600" />
            <span>
              Linked to <b>@{tgStatus?.bot_username}</b>
            </span>
            {tgStatus?.linked_at && (
              <span className="text-xs text-gray-400">
                · since {new Date(tgStatus.linked_at).toLocaleDateString()}
              </span>
            )}
          </div>
          <div className="flex gap-2">
            <Button size="sm" variant="outline" onClick={onSendTest} data-testid="tg-test-btn">
              Send test
            </Button>
            <Button
              size="sm"
              variant="outline"
              className="text-red-600"
              onClick={onUnlink}
              data-testid="tg-unlink-btn"
            >
              <Unlink size={14} className="mr-1" /> Unlink
            </Button>
          </div>
        </div>
      ) : (
        <div className="space-y-3">
          <p className="text-sm text-gray-600">
            Link your Telegram to receive alerts from <b>@{tgStatus?.bot_username || 'the bot'}</b>.
          </p>
          <div className="flex flex-wrap gap-2">
            <Button
              onClick={onStartLink}
              disabled={linking}
              className="bg-purple-600 hover:bg-purple-700"
              data-testid="tg-link-btn"
            >
              <LinkIcon size={14} className="mr-1" />
              {linking ? 'Generating link…' : 'Link Telegram'}
            </Button>
            {deepLink && (
              <a
                href={deepLink.deep_link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm underline text-purple-700 self-center"
                data-testid="tg-deeplink-anchor"
              >
                Open {deepLink.bot_username} in Telegram
              </a>
            )}
          </div>
          {deepLink && (
            <p className="text-xs text-gray-500">
              Tap <b>Start</b> in Telegram.{' '}
              {polling ? 'Waiting for confirmation…' : 'Link expires in 15 minutes.'}
            </p>
          )}
        </div>
      )}
    </CardContent>
  </Card>
);

export default TelegramCard;
